import './news.scss';

export default () => {

};
